/**
 * Centralized Logo Configuration
 * This file contains the Pollar logo file paths and components.
 * Logo files are stored in /public/assets/logo/ directory.
 */

// Logo file paths (relative to public folder)
export const LOGO_PATHS = {
  svg: '/assets/logo/pollar.svg',
  png: '/assets/logo/pollar.png',
  // Legacy paths for backward compatibility
  small: '/assets/logo/pollar.svg',
  medium: '/assets/logo/pollar.svg',
  large: '/assets/logo/pollar.svg',
};

// React component version for use in JSX - uses external SVG file
export const PollarLogoSVG = ({ className = "w-12 h-12" }) => {
  return (
    <img src="/assets/logo/pollar.svg" alt="Pollar Logo" className={className} />
  );
};

// Helper function to get full URL for emails (uses PNG for better email compatibility)
export const getLogoEmailUrl = (frontendUrl) => {
  return `${frontendUrl}/assets/logo/pollar.png`;
};

// Logo component with img tag (for better email compatibility)
export const PollarLogoImg = ({ size = 'medium', alt = 'Pollar Logo', className = '' }) => {
  const sizePath = LOGO_PATHS[size] || LOGO_PATHS.medium;
  return <img src={sizePath} alt={alt} className={className} />;
};

export default {
  LOGO_PATHS,
  PollarLogoSVG,
  PollarLogoImg,
  getLogoEmailUrl
};
